import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@material-ui/core';
import { Warning } from '@material-ui/icons';
import strings from '../localization';

const AgeValidationModal = ({ 
    open, 
    onClose, 
    message, 
    currentAge, 
    requiredAge 
}) => {
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            aria-labelledby="age-validation-dialog-title"
        >
            <DialogTitle id="age-validation-dialog-title" style={{ textAlign: 'center', paddingBottom: '10px' }}>
                <Box display="flex" alignItems="center" justifyContent="center" style={{ color: '#f44336' }}>
                    <Warning style={{ marginRight: '10px', fontSize: '2rem' }} />
                    <Typography variant="h6" component="span">
                        Age Requirement Not Met
                    </Typography>
                </Box>
            </DialogTitle>
            
            <DialogContent style={{ textAlign: 'center', padding: '20px' }}>
                <Typography variant="body1" style={{ marginBottom: '20px', lineHeight: 1.6 }}>
                    {message}
                </Typography>
                
                <Box 
                    style={{ 
                        backgroundColor: '#f5f5f5', 
                        padding: '15px', 
                        borderRadius: '8px',
                        marginTop: '20px'
                    }}
                >
                    <Typography variant="body2" color="textSecondary">
                        <strong>Current Age:</strong> {currentAge} years old
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginTop: '5px' }}>
                        <strong>Required Age:</strong> {requiredAge} years old
                    </Typography>
                </Box>
                
                <Typography variant="body2" style={{ marginTop: '20px', color: '#666' }}>
                    Please contact our recruitment team if you have any questions about age requirements.
                </Typography>
            </DialogContent>
            
            <DialogActions style={{ justifyContent: 'center', padding: '20px' }}>
                <Button 
                    onClick={onClose} 
                    variant="contained" 
                    color="primary"
                    style={{ minWidth: '120px' }}
                >
                    Understood
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AgeValidationModal;
